import {dashboardChartColors} from '../../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../../common/BarchartColumn';

export const prop = 'status';
export const id = 'taskStatusColumn';

export const config = (labels) =>
	barchartColumnConfig({
		fullId: id,
		label: labels.taskStatus,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.completeUpperCase,
				data: [item.allTC],
				color: dashboardChartColors.green[3]
			},
			{
				name: utilLabels.inReview,
				data: [item.allTIR],
				color: dashboardChartColors.green[2]
			},
			{
				name: utilLabels.inProgress,
				data: [item.allTIP],
				color: dashboardChartColors.green[1]
			},
			{
				name: utilLabels.open,
				data: [item.allTO],
				color: dashboardChartColors.green[0]
			}
		]
	});
